module.exports = __webpack_public_path__ + "videos/video-768.d646cfa.mp4";